import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SuperAdminLogin from "@/pages/SuperAdminLogin";
import AdminLogin from "@/pages/AdminLogin";
import UserLogin from "@/pages/UserLogin";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import UserDashboard from "@/pages/UserDashboard";
import Landing from "@/pages/Landing";
import { useEffect } from "react";

export const SUPERADMIN_PATH = process.env.REACT_APP_SUPERADMIN_PATH || "/superadmin-login";
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "/admin-login";

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "superadmin") return <Navigate to="/superadmin" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "user") return <Navigate to="/app" replace />;
  return <Navigate to="/login" replace />;
}

function ThemeInit() {
  useEffect(() => {
    const stored = localStorage.getItem("tk_theme");
    const dark = stored ? stored === "dark" : false;
    document.documentElement.classList.toggle("dark", dark);
  }, []);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <ThemeInit />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path={ADMIN_PATH} element={<AdminLogin />} />
          <Route path={SUPERADMIN_PATH} element={<SuperAdminLogin />} />
          <Route path="/superadmin" element={<ProtectedRoute role="superadmin"><SuperAdminDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/app" element={<ProtectedRoute role="user"><UserDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
